import mapBaseAttachmentDesc from './mapBaseAttachmentDesc';
import { PhotoDesc } from '90.quickConnect.Models/models';

const mapPhotoDesc = (field: PhotoDesc): PhotoDesc =>
  ({
    ...mapBaseAttachmentDesc(field),
  } as PhotoDesc);

export default mapPhotoDesc;
